class AppsController {
  constructor(AppsService, $window, $state, $transitions) {
    'ngInject';
    Object.assign(this, {AppsService, $state});
    this.apps = {
      "Progetto Manager": {
        icon: require('../../img/apps.pm.png'),
        icon_active: require('../../img/apps.pm-active.png'),
        state: '.projectManager'
      },
      "Agenda Digitale": {
        icon: require('../../img/apps.agenda-digitale.png'),
        icon_active: require('../../img/apps.agenda-digitale-active.png'),
        state: '.digitalAgenda'
      },
      "Youtube": {
        icon: require('../../img/apps.youtube.png'),
        icon_active: require('../../img/apps.youtube-active.png'),
        state: '.youtube'
      }
    };
    // hide apps when on phones
    this.isBigScreen = $window.innerWidth >= 768;
    // start loading digital agenda on tablet
    if (this.isBigScreen && !this.isAppSelected()) $state.go('apps.digitalAgenda');
    // when coming back to apps link in tablet
    $transitions.onSuccess({to: 'apps'}, () => {
      if (this.isBigScreen) $state.go('apps.digitalAgenda');
    });
  }

  /**
   * In big screens app list is always visible, in phones only when no app is selected
   * @returns {boolean|*}
   */
  showAppMenu() {
    return this.isBigScreen || !this.isAppSelected();
  }

  /**
   * In big screens app navigator is always hidden, in phones is only visible when an app is selected
   * @returns {boolean|*}
   */
  hideAppNavigator() {
    return this.showAppMenu();
  }

  isAppSelected() {
    return this.$state.current.name !== 'apps'; // i.e. no app selected
  }
}

export default AppsController;



// WEBPACK FOOTER //
// ./client/app/components/apps/apps.controller.js